import React, {useState} from "react";
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {HelpOutlineOutlined} from "@mui/icons-material";
import {MONOSPACE_FONT} from "./dlvStyles";

function Code({children}) {
    return (
        <Box component="code" sx={{fontFamily: MONOSPACE_FONT, fontSize: '0.85em', bgcolor: 'action.hover', px: 0.75, py: 0.25, borderRadius: 0.5}}>
            {children}
        </Box>
    );
}

/**
 * Button that explains how to write the tests, in a dialog.
 */
export function DlvTestsHelp() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Tooltip title="Come scrivere i test">
                <IconButton size="small" aria-label="Come scrivere i test" onClick={() => setOpen(true)}>
                    <HelpOutlineOutlined/>
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" scroll="paper">
                <DialogTitle>Come scrivere i test</DialogTitle>
                <DialogContent dividers>
                    <Stack spacing={2}>
                        <Typography>
                            Ogni caso ha i fatti in input (<Code>facts</Code>) e gli atomi che devono comparire in
                            output (<Code>expected</Code>). La descrizione (<Code>description</Code>) è facoltativa e
                            compare nei risultati.
                        </Typography>
                        <Box>
                            <Typography variant="subtitle2" sx={{mb: 1}}>Negli atomi attesi</Typography>
                            <Stack component="ul" spacing={1} sx={{m: 0, pl: 2.5}}>
                                <Typography component="li">
                                    <Code>destinazione(p1, stroke_unit)</Code>: l'atomo deve esserci così com'è.
                                </Typography>
                                <Typography component="li">
                                    Le lettere maiuscole sono variabili, per esempio <Code>destinazione(p1, D)</Code>:
                                    accettano qualsiasi valore e quello trovato compare nei risultati.
                                </Typography>
                                <Typography component="li">
                                    <Code>_</Code> accetta qualsiasi valore senza mostrarlo, per esempio{' '}
                                    <Code>dato_mancante(p9, _)</Code>.
                                </Typography>
                                <Typography component="li">
                                    <Code>not</Code> richiede che l'atomo non ci sia, per esempio{' '}
                                    <Code>not destinazione(p9, _)</Code>.
                                </Typography>
                            </Stack>
                        </Box>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{px: 3, py: 2}}>
                    <Button variant="contained" onClick={() => setOpen(false)} sx={{textTransform: 'none'}}>Chiudi</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
